import React from "react";
import "./stars.scss";
import Typed from "react-typed";
import logo2 from "../img/Gopala13.png";
class Intro extends React.Component {
  render() {
    return (
      // <div id="home" className="intro route bg-image " style={{backgroundImage: "url("+bigImage+")"}}>
      <div id="home" className="intro route bg-image background">
        <div id="stars" />
        <div id="stars2" />
        <div id="stars3" />

        <div className="intro-content display-table">
          <div className="table-cell">
            <div className="container">
              <a className="navbar-brand js-scroll" href="#page-top">
                <img
                  src={logo2}
                  alt="logo"
                  style={{ maxWidth: "180px", borderRadius: "50%" }}
                />
              </a>
              <h1 className="intro-title mb-4">Hello, I am Gopala</h1>
              <p className="intro-subtitle">
                <span className="text-slider-items"></span>
                <strong className="text-slider">
                  <Typed
                    strings={["Full-Stack Web Developer"]}
                    typeSpeed={80}
                    backDelay={1100}
                    backSpeed={30}
                    loop
                  />
                </strong>
              </p>
              <p className="pt-3">
                <a
                  className="btn btn-primary btn js-scroll px-4"
                  href="#work"
                  role="button"
                >
                  View My Work
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Intro;
